var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-grid-container"},[_c('ag-grid-vue',{ref:"agGrid",staticClass:"ag-theme-material",staticStyle:{"width":"100%","height":"310px"},attrs:{"columnDefs":_vm.columnDefs,"gridOptions":_vm.gridOptions,"rowData":_vm.rows,"defaultColDef":_vm.defaultColDef}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee68969","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cultura/sections/results/ResultsTable.vue
// module id = 1898
// module chunks = 2